// initializeConfig.js

import services from '@demo/services';
import urlConfig from './config/urlConfig';

// import { env } from 'process';
// import config from './config';

export const initializeConfig = async () => {
  try {
    const response = await fetch('./url.json'); // Fetch the configuration from an external source
    const data = await response.json();
    urlConfig.serviceUrlTargetX = data.serviceUrlTargetX;
    urlConfig.serviceUrlSLM = data.serviceUrlSLM;
    services.common.setUrls();
    services.article.setUrls();
    // env.serviceUrl
    console.log('Configuration initialized:', urlConfig);
  } catch (error) {
    console.error('Error initializing configuration:', error);
  }
};
